import React from 'react';
import cn from 'classnames';
import images from 'src/static/assets';
import { analytics } from 'src/utils';

import css from './Socials.module.scss';

type Props = {
  className?: string;
};

enum SHARE {
  FACEBOOK = 'Facebook',
  WHATSAPP = 'Whatsapp',
  TWITTER = 'Twitter',
}

const Socials = (props: Props) => {
  const { className = '' } = props;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = React.useState(false);

  const onToggleBtnClick = () => {
    setIsOpen(!isOpen);
  };

  const onSocialBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const id = e.currentTarget.dataset.id as SHARE;
    const domain = `${window.location.origin}${window.location.pathname}`;
    const title = document.querySelector('meta[property="og:title"]')?.getAttribute('content') || '';
    const description = document.querySelector('meta[property="og:description"]')?.getAttribute('content') || '';

    switch (id) {
      case SHARE.FACEBOOK: {
        const FACEBOOK_URL = 'https://www.facebook.com/sharer.php?u=';

        window.open(`${FACEBOOK_URL}${domain}`, 'sharer', 'width=555,height=600');
        break;
      }

      case SHARE.WHATSAPP: {
        const text = `${title}\n${description}\n${domain}`;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (!isMobile) {
          window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(`${text}`)}`, '_blank');
        } else {
          window.location.href = `whatsapp://send?text=${encodeURIComponent(`${text}`)}`;
        }
        break;
      }

      case SHARE.TWITTER: {
        const twURL = 'https://twitter.com/intent/tweet?url=';
        const twText = `${title}\n${description}`;
        const finalURL = `${twURL}${domain}&text=${encodeURIComponent(`${twText}`)}`;

        const shareWindow = window.open(finalURL, 'ShareOnTwitter', 'width=555,height=600');
        if (shareWindow) shareWindow.opener = null;
        break;
      }

      default:
        break;
    }

    analytics.gtag.event('Share logo', { CUSTOM_PARAMETER: id });
  };

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleOutsideClick = (e: MouseEvent) => {
      if (!container.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <div className={cn(css.socials, isOpen && css.open, className)} ref={containerRef}>
      <button className={css.toggleBtn} type="button" onClick={onToggleBtnClick}>
        <img src={images.shareToggle} />
      </button>
      <div className={css.btns}>
        <button data-id={SHARE.WHATSAPP} type="button" onClick={onSocialBtnClick}>
          <img src={images.whatsapp} alt="whatsapp" />
        </button>
        <button data-id={SHARE.TWITTER} type="button" onClick={onSocialBtnClick}>
          <img src={images.twitter} alt="mail" />
        </button>
        <button data-id={SHARE.FACEBOOK} type="button" onClick={onSocialBtnClick}>
          <img src={images.facebook} alt="facebook" />
        </button>
      </div>
    </div>
  );
};

export default Socials;
